import { useState } from "react";
import { Send, CheckCircle2, CalendarCheck } from "lucide-react";
import { brand, services } from "../mock";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "./ui/select";
import { useToast } from "../hooks/use-toast";

export default function ContactForm({ prefill = "" }) {
  const { toast } = useToast();
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({
    name: "", email: "", phone: "", service: "", message: prefill,
  });

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || (!form.email && !form.phone)) {
      toast({ title: "Campi mancanti", description: "Inserisci il nome e almeno un recapito (email o telefono)." });
      return;
    }
    const leads = JSON.parse(localStorage.getItem("leads") || "[]");
    leads.push({ ...form, at: new Date().toISOString() });
    localStorage.setItem("leads", JSON.stringify(leads));
    setSent(true);
    toast({ title: "Richiesta inviata!", description: "Ti ricontatteremo al più presto per confermare l'appuntamento." });
  };

  return (
    <section id="contatti" className="py-20 bg-[#f5f6f8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
          <div>
            <span className="text-[#e2001a] font-semibold text-sm uppercase tracking-wide">Prenota</span>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-[#16181d] mt-2">
              Prenota il tuo appuntamento
            </h2>
            <p className="text-gray-500 mt-3 max-w-md">
              Revisione, tagliando, cambio gomme o un preventivo? Compila il modulo: ti
              ricontatteremo per fissare giorno e ora più comodi per te.
            </p>
            <div className="mt-8 space-y-4 text-[#16181d]">
              <p className="font-semibold">Oppure chiamaci direttamente</p>
              <a href={brand.phoneHref} className="font-display font-extrabold text-3xl text-[#e2001a] block">{brand.phone}</a>
              <p className="text-sm text-gray-500">Emergenze: <a href={brand.emergencyHref} className="text-[#16181d] font-medium hover:text-[#e2001a]">{brand.emergency}</a></p>
              <a href={`mailto:${brand.email}`} className="text-gray-600 hover:text-[#e2001a] block">{brand.email}</a>
            </div>
          </div>

          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 sm:p-8">
            {sent ? (
              <div className="text-center py-10">
                <CheckCircle2 className="w-16 h-16 text-emerald-500 mx-auto" />
                <h3 className="font-display font-bold text-2xl text-[#16181d] mt-4">Grazie, {form.name}!</h3>
                <p className="text-gray-500 mt-2">La tua richiesta è stata inviata. Ti contatteremo a breve.</p>
                <Button onClick={() => { setSent(false); setForm({ name: "", email: "", phone: "", service: "", message: "" }); }} className="mt-6 rounded-full bg-[#e2001a] hover:bg-[#c00016]">
                  Invia un'altra richiesta
                </Button>
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <Label htmlFor="name">Nome e cognome *</Label>
                    <Input id="name" value={form.name} onChange={update("name")} className="mt-1.5 h-11" placeholder="Mario Rossi" />
                  </div>
                  <div>
                    <Label htmlFor="phone">Telefono</Label>
                    <Input id="phone" value={form.phone} onChange={update("phone")} className="mt-1.5 h-11" placeholder="+39 ..." />
                  </div>
                </div>
                <div>
                  <Label htmlFor="email">Email</Label>
                  <Input id="email" type="email" value={form.email} onChange={update("email")} className="mt-1.5 h-11" placeholder="mario@email.it" />
                </div>
                <div>
                  <Label>Servizio richiesto</Label>
                  <Select value={form.service} onValueChange={(v) => setForm((f) => ({ ...f, service: v }))}>
                    <SelectTrigger className="mt-1.5 h-11"><SelectValue placeholder="Seleziona un servizio" /></SelectTrigger>
                    <SelectContent>
                      {services.map((s) => (
                        <SelectItem key={s.id} value={s.title}>{s.title}</SelectItem>
                      ))}
                      <SelectItem value="Altro / Preventivo">Altro / Preventivo</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label htmlFor="message">Messaggio</Label>
                  <Textarea id="message" value={form.message} onChange={update("message")} className="mt-1.5" rows={4} placeholder="Descrivi la tua richiesta o il tuo veicolo..." />
                </div>
                <Button type="submit" className="w-full h-12 rounded-xl bg-[#e2001a] hover:bg-[#c00016] font-semibold">
                  <CalendarCheck className="w-4 h-4 mr-2" /> Richiedi appuntamento
                </Button>
                <p className="text-xs text-gray-400 text-center">Inviando accetti la nostra Privacy Policy.</p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
